<template>
    <label data-component="switch" :class="classes.label">
        <input
            :checked="modelValue"
            @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
            v-bind="$attrs"
            type="checkbox"
        />
        <span :class="classes.slider"></span>
    </label>
</template>

<script lang="ts">
export default {
    name: "SwitchButton",
};
</script>

<script setup lang="ts">
import { useCssModule } from "vue";

const { modelValue } = defineProps<{ modelValue: boolean }>();
const emit = defineEmits<{ (e: "update:modelValue", value: boolean): void }>();

const classes = useCssModule();
</script>

<style module>
.label {
    position: relative;
    display: inline-block;
    flex-shrink: 0;
    width: 30px;
    height: 20px;

    input {
        opacity: 0;
        width: 0;
        height: 0;

        &:checked + .slider {
            background-color: black;
            border-color: black;

            &::before {
                transform: translateX(8px);
                background-color: white;
            }
        }
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: white;
        border-radius: 34px;
        transition: 0.4s;
        border: 2px solid #808d9a;

        &::before {
            position: absolute;
            content: "";
            height: 12px;
            width: 12px;
            left: 3px;
            bottom: 2px;
            background-color: #808d9a;
            border-radius: 50%;
            transition: 0.4s;
        }
    }
}
</style>
